import type {
    WeekdayShortName} from "@@/shared/parse-weekly-schedule";
import {
    weekDayShortNameZodSchema,
} from "@@/shared/parse-weekly-schedule";
import type {
    DailySchedule} from "@@/shared/weekly-schedules/daily-schedule";
import {
    dailyScheduleFactory,
} from "@@/shared/weekly-schedules/daily-schedule";
import { dailyScheduleTimeRangeFactory } from "@@/shared/weekly-schedules/daily-schedule-time-range";
import type { WeeklySchedule } from "@@/shared/weekly-schedules/weekly-schedule";
import { z } from "zod";
import type {
    DateAgnosticTimeRange} from "./date-agnostic-time-range";
import {
    dateAgnosticTimeRangeZodSchema,
} from "./date-agnostic-time-range";

type WeekAvailability = {
    _type: "WEEK_AVAILABILITY";
    timezone: "Europe/Stockholm";
    week: { [key in WeekdayShortName]?: DateAgnosticTimeRange[] };
};

const weekAvailabilityZodSchema: z.ZodSchema<WeekAvailability> = z.object({
    _type: z.literal("WEEK_AVAILABILITY"),
    timezone: z.enum(["Europe/Stockholm"]),
    week: z.record(
        weekDayShortNameZodSchema,
        z.array(dateAgnosticTimeRangeZodSchema),
    ),
});

const dateAgnosticTimeRangesToDailySchedules = (
    timeRanges: DateAgnosticTimeRange[] | undefined,
): DailySchedule[] => {
    if (typeof timeRanges === "undefined") return [];
    return timeRanges.map(item => {
        const timeRanges = dailyScheduleTimeRangeFactory(
            { hour: item.start.hour, minute: item.start.minute },
            { hour: item.end.hour, minute: item.end.minute },
        );
        if (timeRanges.length > 1)
            throw new Error(
                "So far unsupported availability to schedule conversion",
            );
        const output: DailySchedule = dailyScheduleFactory({
            timeRange: timeRanges[0],
            orderTimePadding: undefined,
        });
        return output;
    });
};

const weekAvailabilityToWeeklySchedule = (
    availability: WeekAvailability,
): WeeklySchedule => {
    return {
        mon: dateAgnosticTimeRangesToDailySchedules(availability.week.mon),
        tue: dateAgnosticTimeRangesToDailySchedules(availability.week.tue),
        wed: dateAgnosticTimeRangesToDailySchedules(availability.week.wed),
        thu: dateAgnosticTimeRangesToDailySchedules(availability.week.thu),
        fri: dateAgnosticTimeRangesToDailySchedules(availability.week.fri),
        sat: dateAgnosticTimeRangesToDailySchedules(availability.week.sat),
        sun: dateAgnosticTimeRangesToDailySchedules(availability.week.sun),
    };
};

export { weekAvailabilityToWeeklySchedule, weekAvailabilityZodSchema };
export type { WeekAvailability };
